export default "__VITE_ASSET__DCSrwTxa__"